import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./modal.css";
import Button from "../UIComponents/Button";
import { updateFormData } from "../../redux/features/formSlice";
import { useDispatch } from "react-redux";

const SessionExpireModal = (props) => {
  const dispatch = useDispatch();
  const handleModalClose = () => {
    dispatch(updateFormData({ field: "scheduleDate", value: "" }));
    dispatch(updateFormData({ field: "scheduleTime", value: "" }));
    props.onHide();
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        dialogClassName="term-modal-main-wrapper session-modal-main-wrapper"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="confirm-modal-main-wrapper">
            <div className="term-modal-main-wrap">
              <div className="close-icon-wrap">
                <img
                  onClick={handleModalClose}
                  src="./assets/icons/close-icon.svg"
                  alt="icon"
                />
              </div>

              <div className="term-modal-content-wrap">
                <h3 className="time-slot-modal-heading no-service-modal-heading">
                  Session Expire
                </h3>

                <p className="time-slot-modal-contant">
                  Your session has expired due to inactivity. It seems you
                  haven't completed your booking within 15 minutes.To continue
                  with your booking, please select a new time slot.
                </p>
              </div>

              <div className="pay-button-wrapper timeslot-modal-btn">
                <Button label="Ok" onClick={handleModalClose} />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default SessionExpireModal;
